getSessionDetails